var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 37,
    viewBox: "0 0 118 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.95,
    cy: 19.25,
    r: 13.95,
    fill: "#00D462",
    fillOpacity: 0.34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.45,
    cy: 19.25,
    r: 13.95,
    fill: "#00D462"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.016 29L56.28 32.328L53.816 34.888L50.84 36.776L50.232 35.496L52.152 34.024L53.496 32.008L53.88 29L53.912 24.04V17.896L53.624 14.568L51.416 14.664L51.256 13.544L55.672 12.68L57.272 13.032L57.048 17.384L56.92 20.584L57.016 29ZM53.432 6.344L54.904 5.64L56.44 6.152L57.144 7.88L56.248 9.288L54.744 9.896L53.336 9.032L52.664 7.592L53.432 6.344ZM60.5918 22.92V18.728L62.4798 14.92L66.0958 12.52L70.4798 12.36L74.4798 14.76L76.5598 18.6L76.1758 24.456L73.8078 28.232L68.8478 29.64L64.6878 28.84L61.6478 26.088L60.5918 22.92ZM64.1118 17.64L63.9518 21.224L64.3358 24.936L65.7118 27.336L69.1038 28.168L72.2398 26.792L73.1678 21.8L72.8478 17.64L71.6638 14.984L69.3278 13.8L66.1278 14.152L64.1118 17.64ZM83.0613 14.376L83.2853 14.6L86.6133 12.776L90.1013 12.68L93.4933 15.272L94.8373 20.616L93.8773 25.384L91.5733 28.296L86.9653 29.64L80.9173 28.84L79.7973 27.72L80.0533 17.16L80.0213 9.896L79.8613 6.696L77.5892 6.792L77.4292 5.672L81.8453 4.808L83.4453 5.16L83.0613 14.376ZM82.9973 24.104L83.2533 27.08L87.4133 28.008L90.5813 26.024L91.5093 22.504L91.3813 18.28L89.1093 14.984L87.1253 14.504L83.0613 16.136L82.9973 24.104ZM98.8458 6.344L100.318 5.64L101.854 6.152L102.558 7.88L101.662 9.288L100.158 9.896L98.7498 9.032L98.0778 7.592L98.8458 6.344ZM102.462 17.384L102.27 20.584L102.366 23.688L102.494 27.4L104.83 28.04L104.67 29.16L100.894 29L96.9898 29.16L97.0538 28.04L99.1658 27.4L99.3258 24.04L99.2618 17.896L99.1018 14.568L96.8298 14.664L96.6698 13.544L101.086 12.68L102.686 13.032L102.462 17.384Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.dba954e5725d87f8a492e5b5a015dbae.svg";
export { ForwardRef as ReactComponent };